import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-success-page',
    template: require('./success.template.html'),
    styles: [`
        #success-container {
            margin-bottom: 20px;
        }
        #success-icon {
            color: #5E9A4F;
            font-size: 6em;
        }
        #success-title {
            font-size: 34px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
        }
    `]
})
export class SuccessPageComponent {
    @Input() title: string = null;

    constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/success-page/success.component.ts